import { render, staticRenderFns } from "./ExplorerAmos.vue?vue&type=template&id=329f486f&scoped=true&"
import script from "./ExplorerAmos.vue?vue&type=script&lang=ts&"
export * from "./ExplorerAmos.vue?vue&type=script&lang=ts&"
import style0 from "./ExplorerAmos.vue?vue&type=style&index=0&id=329f486f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329f486f",
  null
  
)

export default component.exports